export enum Timeframe {
  Hour,
  Day,
  Week,
  Month,
}

export interface BaseTableDataProps {
  label: string | JSX.Element;
  value: string | JSX.Element;
  extra?: string | JSX.Element;
}

export type BaseTableData = BaseTableDataProps;

export interface UsageHistoryData {
  calls: number;
  month: string;
}

export interface UsageHistoryDataMapped extends UsageHistoryData {
  formattedCallsValue: string;
  monthFullName: string;
}

export type TranslationNumberFn = (value: number) => string;
export type TranslationDateFn = (value: Date) => string;

export interface TranslationRequestWidget {
  date: TranslationDateFn;
  time: TranslationDateFn;
  callsCount: TranslationNumberFn;
  title: string;
}
